export const ExternalRoute = {
  telegramPath: () => 'https://web.telegram.org/',
  discordPath: () => 'https://discord.com/',
  vkPath: () => 'https://vk.com/',
};
